import React, { useEffect, useState } from 'react'

import { MAX_UPLOADED_IMAGE_SIZE_SMALL } from '../../../constants'

import emptyAvatarBoy from '../../../assets/icon/empty-avatar-boy.svg'
import emptyAvatarGirl from '../../../assets/icon/empty-avatar-girl.svg'
import addIcon from '../../../assets/icon/add-icon.svg'

const UploadAvatar = ({ defaultAvatar, picture, gender, onResetAvatar = () => {}, children }) => {
  const [bigFileCustomError, setBigFileCustomError] = useState(false)
  const [invalidTypeCustomError, setInvalidTypeCustomError] = useState(false)
  const [isError, setIsError] = useState(false)

  const handleLoadStart = () => {
    setIsError(false)
  }

  const handleError = () => {
    setIsError(true)
  }

  useEffect(() => {
    if (!picture || !picture[0]) return

    const file = picture[0]

    setBigFileCustomError(false)
    setInvalidTypeCustomError(false)

    if (!file.type.includes('image')) {
      setInvalidTypeCustomError(true)
      onResetAvatar()
      return
    }

    if (file.size > MAX_UPLOADED_IMAGE_SIZE_SMALL) {
      setBigFileCustomError(true)
      onResetAvatar()
      return
    }
  }, [picture])

  return (
    <div className="flex flex-col items-center justify-center mb-6">
      <div className="relative">
        <div className="bg-gray-400 w-[100px] h-[100px] rounded-full relative">
          <img
            src={
              picture && picture?.[0]
                ? URL.createObjectURL(picture[0])
                : isError
                  ? gender === 'F'
                    ? emptyAvatarGirl
                    : emptyAvatarBoy
                  : defaultAvatar || (gender === 'F' ? emptyAvatarGirl : emptyAvatarBoy)
            }
            alt="Avatar"
            onLoadStart={handleLoadStart}
            onError={handleError}
            className="w-full h-full block object-cover rounded-full"
          />

          <label className="absolute bottom-0 right-0">
            {children}

            <span role="button">
              <img src={addIcon} alt="Add" />
            </span>
          </label>
        </div>
      </div>

      {bigFileCustomError && (
        <span className="text-sm text-red-500 mt-1.5">File size can’t be more than 2 MB</span>
      )}
      {invalidTypeCustomError && <span className="text-xs text-red-500">Invalid file type</span>}
    </div>
  )
}

export default UploadAvatar
